<script setup lang="ts">
import AdvertisingBlock from '~/entities/advertising/ui/AdvertisingRightBanner.vue';
import AdvertisingImage from './images/advertising-image.jpg';
import {
  SEO_TITLE,
  SEO_DESCRIPTION,
  OG_TYPE,
  OG_SITE_NAME,
  getOgImageMeta,
} from '~/shared/lib/seo';
import { useOrigin } from '~/shared/lib/useOrigin';

const origin = useOrigin();
const title = SEO_TITLE.replace('%%TITLE%%', 'Реклама на сайте');
const canonicalUrl = origin + '/advertising';
useHead({
  title: title,
  link: [{ rel: 'canonical', href: canonicalUrl }],
  meta: [
    { name: 'description', content: SEO_DESCRIPTION },
    { property: 'og:type', content: OG_TYPE },
    { property: 'og:title', content: title },
    { property: 'og:description', content: SEO_DESCRIPTION },
    { property: 'og:site_name', content: OG_SITE_NAME },
    ...getOgImageMeta(origin),
  ],
});
</script>

<template>
  <div :class="$style.static__page">
    <PageHeader title="Реклама на сайте" :show-border-bottom="false" />
    <AdvertisingBlock button-text="Посмотреть форматы баннерной сетки" />
    <img :src="AdvertisingImage" :class="$style.static__page_img" alt="" />
  </div>
</template>

<style module lang="scss">
.static__page {
  &_img {
    padding: var(--space-2-5x);
    width: 100%;
    height: 560px;
    object-fit: cover;
  }
}

@media (max-width: 1379px) {
  .static__page {
    &_img {
      padding: var(--space-2x);
      height: 368px;
    }
  }
}

@media (max-width: 1023px) {
  .static__page {
    &_img {
      height: 392px;
    }
  }
}

@media (max-width: 767px) {
  .static__page {
    &_img {
      height: 236px;
    }
  }
}

@media (max-width: 479px) {
  .static__page {
    &_img {
      padding: 0;
      height: 192px;
    }
  }
}
</style>
